import React from 'react';
import { Input } from '../../../components/ui';

const WeekNumberField = ({ formData }) => (
  <Input
    id="weekNumber"
    name="weekNumber"
    type="number"
    label="Week number"
    value={formData.weekNumber}
    readOnly
    disabled
    placeholder="Auto-generated from current date"
    hint="Calculated automatically from the current date."
  />
);

export default WeekNumberField;
